var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 750,
    height: 750,
    viewBox: "0 0 750 750",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M375 737.5C575.203 737.5 737.5 575.203 737.5 375C737.5 174.797 575.203 12.5 375 12.5C174.797 12.5 12.5 174.797 12.5 375C12.5 575.203 174.797 737.5 375 737.5Z",
    fill: "#FF5252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M375 750C168.25 750 0 581.75 0 375C0 168.25 168.25 0 375 0C581.75 0 750 168.25 750 375C750 581.75 581.75 750 375 750ZM375 25C182 25 25 182 25 375C25 568 182 725 375 725C568 725 725 568 725 375C725 182 568 25 375 25Z",
    fill: "#FF5252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M400 357.5C394 357.5 388.5 353 387.75 346.75C386.75 340 391.5 333.5 398.25 332.5L610.75 301C617.5 300.25 624 304.75 625 311.5C626 318.25 621.25 324.75 614.5 325.75L402 357.25C401.25 357.25 400.5 357.5 400 357.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M400 357.5C397.25 357.5 394.5 356.5 392 354.75L179.5 181.5C174.25 177.25 173.25 169.25 177.75 164C182.25 158.75 190 157.75 195.25 162.25L407.75 335.5C413 339.75 414 347.75 409.5 353C407.25 355.75 403.75 357.5 400 357.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M360.75 640.75C360.25 640.75 359.5 640.75 359 640.75C352.25 639.75 347.5 633.5 348.25 626.75L387.5 343.5C388 340.5 389.5 337.75 391.75 335.75L520.75 222.5C526 218 533.75 218.5 538.5 223.75C543 229 542.5 236.75 537.25 241.5L411.75 351.75L373 630C372.25 636.25 366.75 640.75 360.75 640.75Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M360.75 640.75C360 640.75 359.5 640.75 358.75 640.5C354.25 639.75 350.5 636.75 349 632.5L175.75 176.25C174.25 172 175 167.25 177.75 163.75C180.5 160.25 185.25 158.75 189.5 159.5L531 219.25C533.5 219.75 535.75 220.75 537.5 222.75L621 304.5C625.5 309 626 316.25 622 321.25L370.5 636C368 639 364.5 640.75 360.75 640.75ZM207 187.75L364.5 603.25L595.5 314.25L523 243L207 187.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrx);
export default __webpack_public_path__ + "static/media/trx.1e3f838850284d2020fa8a4c08906fdf.svg";
export { ForwardRef as ReactComponent };